const TOKEN_KEY  = 'mfai_admin_token';
const USER_KEY   = 'mfai_admin_user';
const DEVICE_KEY = 'mfai_admin_device';

export function saveAdminSession(token, admin) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(admin));
}

export function saveDeviceToken(token) {
  if (token) localStorage.setItem(DEVICE_KEY, token);
}

export function getDeviceToken() {
  return localStorage.getItem(DEVICE_KEY) || null;
}

export function clearAdminSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  // Keep DEVICE_KEY so trusted device persists across sessions
}

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getAdmin() {
  try { return JSON.parse(localStorage.getItem(USER_KEY)); }
  catch { return null; }
}

export function isAdminLoggedIn() {
  return !!getAdminToken() && !!getAdmin();
}
